import { createApp } from '@app/adapters/create-app'
import createStore from '@app/insights/store'
import { initInsightsRootFromDataset } from '@app/insights/store/insights-root'
import type { Store } from 'vuex'
import { createRouter, createWebHistory } from 'vue-router'

import InsightsLeftDrawer from '@app/insights/components/insights-left-drawer.vue'
import type { App as Application } from 'vue'

window.onDomLoad(function ($dom) {
  const doc = $dom[0]
  const element = doc.querySelector(
    "[data-behaviour='insights/companies-left-drawer']"
  ) as HTMLElement

  if (element) {
    const store = createStore() as Store<unknown>

    const router = createRouter({
      history: createWebHistory(),
      routes: [
        {
          path: '/f/:firmid/insights/companies_overview',
          name: 'InsightsLeftDrawer',
          component: InsightsLeftDrawer,
        },
      ],
    })

    const leftDrawerApp: Application = createApp(InsightsLeftDrawer, {
      isLite: element.dataset.liteInsights === 'true',
    })

    leftDrawerApp.use(store)
    leftDrawerApp.use(router)

    initInsightsRootFromDataset(element.dataset)

    leftDrawerApp.mount(element)
  }
})
